export default __webpack_public_path__ + "static/media/star.c5f7a6d4.svg";